export * from './DefaultVariant';
